var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _setup.testappUse
      ? _c("div", [_c(_setup.testappRoot, { tag: "div" })], 1)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "payout" },
      [
        _c(_setup.WaitMessage, { attrs: { ob: _setup.claimob } }),
        _vm._v(" "),
        _setup.claimob.claim
          ? _c("div", [
              _c("div", { staticClass: "claimob" }, [
                _c("div", { staticClass: "claimob-dl claimob-1" }, [
                  _c("div", { staticClass: "claimob-dt" }, [
                    _vm._v("Номер заявки"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "claimob-dd" }, [
                    _c("div", { staticClass: "num" }, [
                      _vm._v("№" + _vm._s(_setup.claimob.claim.num)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small" }, [
                      _vm._v(_vm._s(_setup.claimob.claim.hint_country)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "claimob-dl claimob-2" }, [
                  _c("div", { staticClass: "claimob-dt" }, [
                    _vm._v("Название и № заявки туроператора"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "claimob-dd" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_setup.claimob.claim.oper_avi_ins_name) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(_setup.claimob.claim.identifier) + "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "claimob-dl claimob-3" }, [
                  _c("div", { staticClass: "claimob-dt" }, [_vm._v("Туристы")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "claimob-dd" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_setup.claimob.claim.tourist_short) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "claimob-dl claimob-4" }, [
                  _c("div", { staticClass: "claimob-dt" }, [
                    _vm._v("Дата заезда"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "claimob-dd" }, [
                    _c("div", [
                      _vm._v(_vm._s(_setup.dmy(_setup.claimob.claim.datebeg))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small" }, [
                      _vm._v(
                        _vm._s(
                          _setup.numWord(_setup.claimob.claim.nights, [
                            "ночь",
                            "ночи",
                            "ночей",
                          ])
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [_c("router-view", { key: _setup.route.path })], 1),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "versions" }, [
      _c(
        "a",
        {
          attrs: {
            href: _setup.gitlink,
            title: _setup.gittitle,
            target: "_blank",
          },
        },
        [_vm._v(_vm._s(_setup.ver))]
      ),
      _vm._v(" "),
      _c("span", { attrs: { title: _setup.gate } }, [_vm._v("gate")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }